import React, {Component} from 'react';
import {Container, Row, Col, CardGroup, Card, CardBody, Button, Input, InputGroup, InputGroupText, Form} from 'reactstrap';
import {withRouter} from 'react-router';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {Alert} from 'reactstrap';
import {logUser} from '../../../actions';
import {login} from '../../../gateways/authentication';
import {postForgotPassword} from '../../../gateways/account_management';

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      showForm: 'login',
      forgotPasswordEmail: '',
      alert: {
        color: '',
        message: ''
      }
    }
  }

  clearError() {
    return new Promise(() => { 
      this.setState({ 
        alert: {
          color: "",
          message: ""
        } 
      });
    });
  }

  submitForgotPassword() {
    postForgotPassword(this.state.forgotPasswordEmail)
    .then((result) => {
      if ( result.error ) {
        this.setState({ alert: { color: "warning", message: result.msg }});
      } else {
        this.setState({ alert: { color: "info", message: result.msg }});
      }
    })
    .catch(( error ) => {
        let message = "";
        if ( error.response && error.response.data ) {
          message = error.response.data.message;
        } else {
          message = error.message;
        }
        this.setState({ alert: { color: "danger", message: message }});
    });
  }

  signIn() {
    const { email, password } = this.state;
    login(email, password)
    .then((result) => {
        if ( !result.error ) {
          this.props.logUser({
            user: result.user,
            permissions: result.permissions
          });
          this.props.history.push('/');
        } else {
          this.setState({ alert: { color: "warning", message: "Invalid username or password" }});
        }
    })
    .catch(( error ) => {
        let message = "";
        if ( error.response && error.response.data ) {
          message = error.response.data.message;
        } else {
          message = error.message;
        }
        this.setState({ alert: { color: "danger", message: message }});
    });
  }

  onDismiss() {
    this.clearError();
  }

  renderLoginForm() {
    if ( this.state.showForm === 'login' ) {
      return (
        <div className="animated fadeIn">
          <h1>Login</h1>
          <p className="text-muted">Sign In to your account</p>
          <Alert color={this.state.alert.color} isOpen={this.state.alert.message != ""} toggle={() => this.onDismiss()}>
            {this.state.alert.message}
          </Alert>
          <Form onSubmit={(e) => { e.preventDefault(); this.signIn(); }}>
            <InputGroup className="mb-3">
              <InputGroupText><i className="icon-user"></i></InputGroupText>
              <Input type="text" placeholder="Email" onChange={event => this.setState({email: event.target.value})}/>
            </InputGroup>
            <InputGroup className="mb-4">
              <InputGroupText><i className="icon-lock"></i></InputGroupText>
              <Input type="password" placeholder="Password" onChange={event => this.setState({password: event.target.value})}/>
            </InputGroup>
            <Row>
              <Col xs="6">
                <Button color="primary" className="px-4" type="submit">Login</Button>
              </Col>
              <Col xs="6" className="text-right">
                <div><Link to="/register" className="px-0 d-lg-none">Register</Link></div>
                <div>
                  <Button color="link"
                    onClick={(e) => { 
                      e.preventDefault(); 
                      this.setState({ "showForm": "forgotPassword" }, () => {
                        this.clearError();
                      });
                    }}  
                    className="px-0">Forgot password?</Button>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      );
    }
  }

  renderForgotPasswordForm() {
    if ( this.state.showForm === 'forgotPassword' ) {
      return (
        <div className="animated fadeIn">
          <h1>Forgot Password</h1>
          <p className="text-muted">Please enter your registered E-mail</p>
          <Alert color={this.state.alert.color} isOpen={this.state.alert.message != ""} toggle={() => this.onDismiss()}>
            {this.state.alert.message}
          </Alert>
          <Form onSubmit={(e) => { e.preventDefault(); this.submitForgotPassword(); }}>
            <InputGroup className="mb-3">
              <InputGroupText><i className="icon-envelope"></i></InputGroupText>
              <Input type="text" placeholder="Email" onChange={event => this.setState({forgotPasswordEmail: event.target.value})}/>
            </InputGroup>
            <Row>
              <Col xs="6">
                <Button color="link" 
                  onClick={(e) => { 
                    e.preventDefault(); 
                    this.setState({ "showForm": "login" }, () => {
                      this.clearError();
                    }); 
                  }} 
                  className="px-0">Back to login
                </Button>
              </Col>
              <Col xs="6" className="text-right">
                <Button color="primary" className="px-4" type="submit">Submit</Button>
              </Col>
            </Row>
          </Form>
        </div>
      );
    }
  }

  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col xs="12" md="8">
              <Card style={{display: "block", "textAlign": "center" }}>
                <img src="./img/logo_login.jpg" style={{ maxWidth: "100%" }}/>
              </Card>
            </Col>
            <Col xs="12" md="8">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    {this.renderLoginForm()}
                    {this.renderForgotPasswordForm()}
                  </CardBody>
                </Card>
                <Card className="text-white bg-primary py-5 d-md-down-none" style={{ width: 44 + '%' }}>
                  <CardBody className="text-center">
                    <div>
                      <h2>Sign up</h2>
                      <p></p>
                      <Link to="/register"><Button color="primary" className="mt-3" active>Register</Button></Link>
                    </div>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withRouter(connect(null, { logUser })(Login));



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js